import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CMSBlock from "./../../components/cms/CMSBLock";
import CustomerSidebar from "components/customers/CustomerSidebar";
import CustomerFormalities from "components/customers/CustomerFormalities";
import CustomerOrders from "components/customers/CustomerOrders";
import CustomerProfile from "components/customers/CustomerProfile";
import UserParameters from "components/user/UserParameters";
import './page-customer-account.css';
const VIEWS = {
  formalities: {
    path: "",
    cmsBlockId: "page-customer-formalities-content-header",
    component: CustomerFormalities,
    title: "Mes demandes de formalités",
  },
  orders: {
    path: "orders",
    cmsBlockId: "page-customer-orders-content-header",
    component: CustomerOrders,
    title: "Mes commandes",
  },
  profile: {
    path: "profile",
    cmsBlockId: "page-customer-profile-content-header",
    component: CustomerProfile,
    title: "Mon compte client",
  },
  parameters: {
    path: "parameters",
    cmsBlockId: "page-customer-parameters-content-header",
    component: UserParameters,
    title: "Mes paramètres de connexion",
  },
};

export default function PageCustomerAccount() {
  const location = useLocation();
  const navigate = useNavigate();

  // -----------------------------
  // Déduction de la vue depuis l'URL
  // -----------------------------
  const view = useMemo(() => {
    const parts = location.pathname
      .replace("/customer/account", "")
      .split("/")
      .filter(Boolean);

    const key = parts[0] || "formalities";

    return VIEWS[key] ? key : "formalities";
  }, [location.pathname]);

  const { cmsBlockId, component: ViewComponent, title = null } =
    VIEWS[view];

  // -----------------------------
  // Navigation depuis la sidebar
  // -----------------------------
  const handleChangeView = (nextView) => {
    const path = VIEWS[nextView]?.path || "";
    navigate(`/customer/account/${path}`);
  };
  return (
    <div id="page-customer-account">
      {/* CMS HEADER DYNAMIQUE */}
      <CMSBlock blockId={cmsBlockId} />

      <div className="container my-5">
        <div className="row">
          <CustomerSidebar
            active={view}
            onChange={handleChangeView}
          />
          <main className="col-12 col-md-9">
            {title &&
              <div className="cms-block-title">
                <h2><span>{title}</span></h2>
              </div>
            }
            <ViewComponent />
          </main>
        </div>
      </div>
    </div>
  );
}
